module.exports = __webpack_public_path__ + "static/img/caishen.f94e1c10.png";